<article class="content-container">
  <main>
    <section>
      @defer (when org) {
        @if (org.id !== 153) {
          <app-energy-list />
        } @else {
          <app-energy-meters />
        }
      } @placeholder {
        Loading
      }
    </section>
  </main>
</article>
